var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"web-layout"}},[_c('WebLayoutHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }